import pageTranslations from './pt/index.js';

function unwrapMessages(moduleValue) {
    let value = moduleValue;

    while (value && typeof value === 'object' && 'default' in value) {
        value = value.default;
    }

    return value && typeof value === 'object' ? value : {};
}

const pages = unwrapMessages(pageTranslations);

export default {
    ...pages,
    welcome: {
        title: 'ShipToMarket | Valide sua ideia de negócio com IA e leads reais',
        description:
            'Análise de mercado, TAM, SAM e viabilidade; depois testes reais com leads antes de investir.',
        login: 'Entrar',
        register: 'Cadastrar',
        contact: 'Contato',
        about: 'Sobre',
        features: 'Recursos',
    },
    common: {
        save: 'Salvar',
        cancel: 'Cancelar',
        next: 'Próximo',
        back: 'Voltar',
        loading: 'Carregando...',
        error: 'Ocorreu um erro',
        optional: 'Opcional',
        getCredits: 'Obter Créditos',
    },
    errors: {
        404: {
            title: 'Página Não Encontrada',
            heading: 'Página Não Encontrada',
            message: 'A página que você está procurando não existe ou foi movida.',
            goToDashboard: 'Ir para o Painel',
            goToHome: 'Ir para Início',
        },
        419: {
            title: 'Sessão Expirada',
            heading: 'Sessão Expirada',
            message: 'Sua sessão expirou. Por favor, recarregue a página para continuar.',
            reloadPage: 'Recarregar Página',
            goToDashboard: 'Ir para o Painel',
            goToHome: 'Ir para Início',
        },
        500: {
            title: 'Erro no Servidor',
            heading: 'Algo Deu Errado',
            message:
                'Estamos enfrentando dificuldades técnicas. Por favor, tente novamente mais tarde.',
            goToDashboard: 'Ir para o Painel',
            goToHome: 'Ir para Início',
        },
        503: {
            title: 'Serviço Indisponível',
            heading: 'Em Manutenção',
            message: 'Estamos realizando manutenção no momento. Por favor, volte em breve.',
        },
    },
};
